import { Loader } from '@ad-lucy/ui';
import styled from 'styled-components';

export const LoaderCentered = styled(Loader)`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
`;
